import React from 'react';
import { HashRouter as Router, Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import Hero from './components/Hero';
import TrialSection from './components/TrialSection';
import Services from './components/Services';
import Process from './components/Process';
import Results from './components/Results';
import Testimonials from './components/Testimonials';
import Pricing from './components/Pricing';
import FAQ from './components/FAQ';
import Contact from './components/Contact';
import Footer from './components/Footer';
import PrivacyPolicy from './pages/PrivacyPolicy';
import TermsConditions from './pages/TermsConditions';
import CookiePolicy from './pages/CookiePolicy';
import ScrollToTop from './components/ScrollToTop';
import CanonicalLink from './components/CanonicalLink';
import PageMeta from './components/PageMeta';
import './App.css';

const Home = () => (
  <>
    <PageMeta 
      title="Living Media | Premium Video Editing for Creators & Brands"
      description="Expert video editing for high-performance creators. We turn raw footage into polished content with fast turnarounds and consistent quality."
    />
    <Hero />
    <TrialSection />
    <Services />
    <Process />
    <Results />
    <Pricing />
    <Testimonials />
    <FAQ />
    <Contact />
  </>
);

function App() {
  return (
    <Router>
      <ScrollToTop />
      <CanonicalLink />
      <div className="min-h-screen bg-black selection:bg-[#BEF264] selection:text-black">
        <Routes>
          <Route path="/" element={
            <>
              <Header />
              <main>
                <Home />
              </main>
              <Footer />
            </>
          } />
          <Route path="/privacy" element={<PrivacyPolicy />} />
          <Route path="/terms" element={<TermsConditions />} />
          <Route path="/cookie-policy" element={<CookiePolicy />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;